import { createSlice } from "@reduxjs/toolkit";

const orderReviewsSlice = createSlice({
  name: "orderReviews",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    setOrderReviewsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setOrderReviews(state, action) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setOrderReviewsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  setOrderReviewsLoading, 
  setOrderReviews, 
  setOrderReviewsError 
} = orderReviewsSlice.actions;

export default orderReviewsSlice.reducer;